import React, { useEffect } from 'react';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import {
	FREE_EDITION,
	STANDARD_EDITION,
	type ApplicationEditions,
} from '@jira/platform__application-editions/src/edition.tsx';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { HandleActionType } from '@atlassian/rovo-conversation-actions/types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const findJiraSettingsTitle = defineMessage({
	id: 'ai-rovo.project-setting-detail-nudge.find-jira-settings-title',
	defaultMessage: 'Find Jira settings',
	description: 'Title for the find Jira settings nudge',
});

const findJiraSettingsDescription = defineMessage({
	id: 'ai-rovo.project-setting-detail-nudge.find-jira-settings-description',
	defaultMessage: 'Learn how the find-jira-settings Rovo Skill can help you',
	description: 'Description for the find Jira settings nudge',
});

const findJiraSettingsPrompt = defineMessage({
	id: 'ai-rovo.project-setting-detail-nudge.find-jira-settings-prompt',
	defaultMessage:
		"This is my first time using the 'find-jira-settings' Rovo Skill. How can it help me?",
	description: 'Prompt for the find Jira settings nudge',
});

const isNudgeEnabledForApplicationEdition = (appEditions: ApplicationEditions) => {
	return (
		appEditions.software === STANDARD_EDITION ||
		appEditions.core === STANDARD_EDITION ||
		appEditions.software === FREE_EDITION ||
		appEditions.core === FREE_EDITION
	);
};

export const AiRovoProjectSettingDetailNudgesProvider: React.FC<{}> = (): null => {
	const appEditions = useAppEditions();
	const { formatMessage } = useIntl();
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();

	useEffect(() => {
		if (!isNudgeEnabledForApplicationEdition(appEditions)) {
			return;
		}

		updateConfiguration({
			nudges: [
				{
					id: 'ai-rovo.project-setting-detail-nudge.find-jira-settings',
					title: formatMessage(findJiraSettingsTitle),
					description: formatMessage(findJiraSettingsDescription),
					icon: () => <AiChatIcon label={formatMessage(findJiraSettingsTitle)} size="medium" />,
					type: 'skill-action',
					handleType: HandleActionType.Skill,
					staticPrompt: `/find-jira-settings ${formatMessage(findJiraSettingsPrompt)}`,
				},
			],
		});
	}, [appEditions, formatMessage, updateConfiguration]);

	return null;
};
